import {
  getAuthHeaderName,
  getAuthHeaderPrefix,
  isCredentialsRequired,
} from '@/config/api/env.js'
import { getAccessToken } from '@/config/api/authStore.js'
import { chatStreamUrl, isPhase1ChatStreamConfigured } from './chatStreamConfig'
import { chatStreamHeaders, chatStreamRequestBody } from './chatStreamRequest'

export { isPhase1ChatStreamConfigured }

export async function postChatStream(params, signal) {
  const token = getAccessToken()
  const res = await fetch(chatStreamUrl(), {
    method: 'POST',
    signal,
    headers: chatStreamHeaders({
      token,
      headerName: getAuthHeaderName(),
      headerPrefix: getAuthHeaderPrefix(),
    }),
    credentials: isCredentialsRequired() ? 'include' : 'same-origin',
    body: chatStreamRequestBody(params),
  })

  if (!res.ok || !res.body) {
    throw new Error(`Chat stream failed (${res.status})`)
  }

  return res
}
